import React from 'react';

import ViewDraftjsText from '../../../../../../../ViewDraftjsText/ViewDraftjsText';


const RegularMessage = ({ message, anchors }) => {
  const className = `message ${message.isMine ? 'message--mine' : ''}`;

  return (
    <li className={className}>
      <div>
        {message.isSeen && (
          <span className="message-read-indicator">Seen</span>
        )}
        <p>
          <ViewDraftjsText
            allAnchors={anchors}
            metadata={message.messageMetadata}
            text={message.message}
          />
        </p>
        <span className="message-time">{message.displayTime}</span>
      </div>
    </li>
  );
};

export default RegularMessage;
